import { render, staticRenderFns } from "./DetailedTips.vue?vue&type=template&id=4aa21496&"
import script from "./DetailedTips.vue?vue&type=script&lang=js&"
export * from "./DetailedTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports